import { useQuery } from '@tanstack/react-query'
import { AppError } from '@shared/api/error'
import { apiFetch } from '@shared/api/http'
import { dashboardPeriodRange } from '../lib/admin-dashboard-period'
import type { AdminDashboardParams, AdminSalesSeries } from './admin.api'

export function useAdminDashboardLiveSeries(params: AdminDashboardParams, enabled: boolean) {
  return useQuery({
    queryKey: ['admin-dashboard-live-series', params],
    queryFn: ({ signal }) => {
      const search = new URLSearchParams()
      const filters = { ...params, ...dashboardPeriodRange('today') }
      for (const [key, value] of Object.entries(filters)) {
        if (value !== undefined) search.set(key, String(value))
      }
      return apiFetch<AdminSalesSeries>(`/admin/dashboard/sales-series?${search}`, { signal })
    },
    enabled,
    refetchInterval: (query) => (query.state.status === 'error' ? false : 30_000),
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    retry: (failureCount, error) =>
      failureCount < 1 && !(error instanceof AppError && error.status >= 500),
  })
}
